import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";

import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const Bentuk = () => {

    const columns = [
        {
            name: 'Kode Bentuk',
            cell: row => row['kdBentuk']
        },
        {
            name: 'Hidup/Non Hidup',
            cell: row => row['hidup'] === 1 ? 'Hidup' : row['hidup'] === 2 ? 'Non Hidup' : 'Lainnya' 
        },
        {
            name: 'Keterangan',
            cell: row => row['ketBentuk']
        }
    ]

    let masterService = useMemo(() => new MasterService(), [])

    const [listBentuk, setListBentuk] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getListBentuk = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await masterService.listBentukIkan(null, null, page, size)
            setListBentuk(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setListBentuk([])
        }
        setLoading(false)
    }, [masterService])

    useEffect(() => {
        getListBentuk(0, 10)
    }, [getListBentuk])

    const handleChangePage = (page) => {
        getListBentuk(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await masterService.listBentukIkan(null, null, page - 1, size)
        setListBentuk(_res.data.data)
        setSize(size)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Master Bentuk Ikan</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listBentuk}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default Bentuk;
